import resources from '../resource.js';

const baseDomain = process.env.VUE_APP_ENDPOINT;

export default {
    login() {
        return `${baseDomain}/login`
    },
    sanctum() {
        return `${baseDomain}/sanctum/csrf-cookie`;
    },
    user() {
        return `${baseDomain}/api/auth-user`
    },
    team(id = '') {
        if (id == '') {
            return `${baseDomain}/api/team`
        }

        return `${baseDomain}/api/team/${id}`
    },
    updateUser() {
        return `${baseDomain}/api/update-user`
    },
    updatePassword() {
        return `${baseDomain}/api/update-password`
    },
    logout() {
        return `${baseDomain}/logout`
    },
    readNotifications() {
        return `${baseDomain}/api/read-notifications`
    }
}
